import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const CompanyInfoStep = ({ formData, updateFormData, errors }) => {
  const companyTypeOptions = [
    { value: 'bv', label: 'Besloten Vennootschap (B.V.)' },
    { value: 'vof', label: 'Vennootschap onder Firma (V.o.F.)' },
    { value: 'eenmanszaak', label: 'Eenmanszaak' },
    { value: 'cv', label: 'Commanditaire Vennootschap (C.V.)' },
    { value: 'nv', label: 'Naamloze Vennootschap (N.V.)' }
  ];

  const handleInputChange = (field, value) => {
    updateFormData({ [field]: value });
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-heading font-semibold text-foreground mb-2">
          Bedrijfsgegevens
        </h2>
        <p className="text-muted-foreground">
          Vul de basisgegevens van uw bedrijf in. Deze informatie wordt gebruikt voor verificatie.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="Bedrijfsnaam"
          type="text"
          placeholder="Bijv. GreenTech Solutions B.V."
          value={formData?.companyName || ''}
          onChange={(e) => handleInputChange('companyName', e?.target?.value)}
          error={errors?.companyName}
          required
        />

        <Input
          label="KvK Nummer"
          type="text"
          placeholder="12345678"
          description="8-cijferig Kamer van Koophandel nummer"
          value={formData?.kvkNumber || ''}
          onChange={(e) => handleInputChange('kvkNumber', e?.target?.value)}
          error={errors?.kvkNumber}
          required
        />

        <Select
          label="Bedrijfsvorm"
          placeholder="Selecteer bedrijfsvorm"
          options={companyTypeOptions}
          value={formData?.companyType || ''}
          onChange={(value) => handleInputChange('companyType', value)}
          error={errors?.companyType}
          required
        />

        <Input
          label="BTW Nummer"
          type="text"
          placeholder="NL123456789B01"
          description="Nederlandse BTW identificatie"
          value={formData?.vatNumber || ''}
          onChange={(e) => handleInputChange('vatNumber', e?.target?.value)}
          error={errors?.vatNumber}
        />

        <Input
          label="Contactpersoon"
          type="text"
          placeholder="Voor- en achternaam"
          value={formData?.contactPerson || ''}
          onChange={(e) => handleInputChange('contactPerson', e?.target?.value)}
          error={errors?.contactPerson}
          required
        />

        <Input
          label="Functie"
          type="text"
          placeholder="Bijv. Directeur, Manager"
          value={formData?.jobTitle || ''}
          onChange={(e) => handleInputChange('jobTitle', e?.target?.value)}
          error={errors?.jobTitle}
        />

        <Input
          label="E-mailadres"
          type="email"
          placeholder="info@uwbedrijf.nl"
          value={formData?.email || ''}
          onChange={(e) => handleInputChange('email', e?.target?.value)}
          error={errors?.email}
          required
        />

        <Input
          label="Telefoonnummer"
          type="tel"
          placeholder="+31 6 12345678"
          value={formData?.phone || ''}
          onChange={(e) => handleInputChange('phone', e?.target?.value)}
          error={errors?.phone}
          required
        />

        <Input
          label="Wachtwoord"
          type="password"
          placeholder="Minimaal 8 karakters"
          description="Wachtwoord voor uw provider account"
          value={formData?.password || ''}
          onChange={(e) => handleInputChange('password', e?.target?.value)}
          error={errors?.password}
          required
        />

        <Input
          label="Bevestig wachtwoord"
          type="password"
          placeholder="Herhaal uw wachtwoord"
          value={formData?.confirmPassword || ''}
          onChange={(e) => handleInputChange('confirmPassword', e?.target?.value)}
          error={errors?.confirmPassword}
          required
        />

        <Input
          label="Website"
          type="url"
          placeholder="https://www.uwbedrijf.nl"
          value={formData?.website || ''}
          onChange={(e) => handleInputChange('website', e?.target?.value)}
          error={errors?.website}
        />

        <Input
          label="Oprichtingsjaar"
          type="number"
          placeholder="2020"
          min="1900"
          max="2024"
          value={formData?.foundedYear || ''}
          onChange={(e) => handleInputChange('foundedYear', e?.target?.value)}
          error={errors?.foundedYear}
        />
      </div>
      <div className="space-y-4">
        <h3 className="text-lg font-heading font-medium text-foreground">
          Bedrijfsadres
        </h3>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="md:col-span-2">
            <Input
              label="Straat en huisnummer"
              type="text"
              placeholder="Hoofdstraat 123"
              value={formData?.address || ''}
              onChange={(e) => handleInputChange('address', e?.target?.value)}
              error={errors?.address}
              required
            />
          </div>
          
          <Input
            label="Postcode"
            type="text"
            placeholder="1234 AB"
            value={formData?.postalCode || ''}
            onChange={(e) => handleInputChange('postalCode', e?.target?.value)}
            error={errors?.postalCode}
            required
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label="Plaats"
            type="text"
            placeholder="Amsterdam"
            value={formData?.city || ''}
            onChange={(e) => handleInputChange('city', e?.target?.value)}
            error={errors?.city}
            required
          />
          
          <Input
            label="Provincie"
            type="text"
            placeholder="Noord-Holland"
            value={formData?.province || ''}
            onChange={(e) => handleInputChange('province', e?.target?.value)}
            error={errors?.province}
            required
          />
        </div>
      </div>
    </div>
  );
};

export default CompanyInfoStep;